import { Collapsible as CollapsiblePrimitive } from "@base-ui/react/collapsible";

import { cn } from "@lib/utils";

/** An interactive component which expands/collapses a panel. */
const Collapsible = ({ className, ...props }: CollapsiblePrimitive.Root.Props) => (
	<CollapsiblePrimitive.Root className={cn("w-full", className)} data-slot="collapsible" {...props} />
);

const CollapsibleTrigger = ({ ...props }: CollapsiblePrimitive.Trigger.Props) => (
	<CollapsiblePrimitive.Trigger data-slot="collapsible-trigger" {...props} />
);

const CollapsibleContent = ({ className, ...props }: CollapsiblePrimitive.Panel.Props) => (
	<CollapsiblePrimitive.Panel
		className={cn(
			`h-(--collapsible-panel-height) overflow-hidden transition-[height] duration-300 ease-out data-ending-style:h-0
			data-ending-style:duration-200 data-ending-style:ease-in data-starting-style:h-0`,
			className,
		)}
		data-slot="collapsible-content"
		{...props}
	/>
);

Collapsible.displayName = "Collapsible";
CollapsibleTrigger.displayName = "CollapsibleTrigger";
CollapsibleContent.displayName = "CollapsibleContent";

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
